import { render } from "./ProjectUpdate.vue?vue&type=template&id=41798dd1"
import script from "./ProjectUpdate.vue?vue&type=script&lang=js"
export * from "./ProjectUpdate.vue?vue&type=script&lang=js"
script.render = render

export default script